//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button'
import ModalBase from '~/components/Shared/ModalBase.vue'

export default {
  components: { Button, ModalBase },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    confirm() {
      this.close()
      this.$emit('confirm')
    },
  },
}
